import React from "react";
import { ThreeDots } from "react-loader-spinner";

const PrimaryButton = ({
  width,
  buttonText,
  onClick,
  type,
  disabled,
  loader,
}) => {
  return (
    <button
      className={`border-none outline-none bg-primary text-white  flex items-center justify-center rounded-lg font-normal font-Nunito text-lg ${width} focus:border-none focus:outline-none h-10 hover:bg-tertiary`}
      onClick={onClick}
      type={type}
      disabled={disabled}
    >
      {loader ? (
        <ThreeDots
          height="40"
          width="80"
          radius="6"
          color="#ffffff"
          ariaLabel="three-dots-loading"
          wrapperStyle={{}}
          wrapperClassName=""
          visible={true}
        />
      ) : (
        buttonText
      )}
    </button>
  );
};

export default PrimaryButton;
